import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { rootPaths } from 'routes/paths';

import { getStartedPaths } from 'features/get-started/routes/paths';
import { FirstStepPage } from 'features/get-started/pages/FirstStepPage';
import { SecondStepPage } from 'features/get-started/pages/SecondStepPage';
import useUser from 'features/user/hooks/useUser';
import { appRoutes } from 'features/app/routes/paths';

export const GetStartedRoutes = () => {
  const { user } = useUser();

  if (user && !user.show_started_tips) {
    return <Redirect to={appRoutes.static.root} />;
  }

  return (
    <Switch>
      <Route exact path={getStartedPaths.static.firstStep} component={FirstStepPage} />
      <Route exact path={getStartedPaths.static.secondStep} component={SecondStepPage} />
      <Route>
        <Redirect to={rootPaths.static.notFound} />
      </Route>
    </Switch>
  );
};
